// Editorial fallback images for room types when the hotel hasn't uploaded
// its own photography. Photos live in /public/rooms/ and ship with the
// bundle. Source: Hotel Palmerola's "Believe Photography by H&M" shoot.
// Each filename reflects the actual bed configuration shown in the shot
// (sencilla = 1 cama, doble = 2 camas, triple = 3 camas, etc).

const SENCILLA = '/rooms/sencilla.jpg'           // 1 cama individual
const SENCILLA_ALT = '/rooms/sencilla-alt.jpg'   // 1 cama, alt shot
const DOBLE = '/rooms/doble.jpg'                 // 2 camas, cortinas elegantes
const SUPERIOR = '/rooms/superior.jpg'           // 2 camas, cabeceras tapizadas
const SUITE = '/rooms/suite.jpg'                 // 2 camas, cabeceras talladas
const PRESIDENCIAL = '/rooms/presidencial.jpg'   // 2 camas refinadas
const TRIPLE = '/rooms/triple.jpg'               // 3 camas
const FAMILIAR = '/rooms/familiar.jpg'           // 3 camas con A/C

export function roomImageFallback(name: string): string {
  const n = name.toLowerCase()
  if (n.includes('presidencial')) return PRESIDENCIAL
  if (n.includes('suite')) return SUITE
  if (n.includes('superior') || n.includes('ejecutiv')) return SUPERIOR
  if (n.includes('familiar')) return FAMILIAR
  if (n.includes('triple')) return TRIPLE
  if (n.includes('doble') || n.includes('twin') || n.includes('dos camas')) return DOBLE
  if (n.includes('sencilla') || n.includes('single') || n.includes('individual') || n.includes('estándar') || n.includes('estandar')) return SENCILLA
  return DOBLE
}

export const ROOM_FALLBACK_GALLERY = [SENCILLA, DOBLE, SUPERIOR, SUITE, PRESIDENCIAL, TRIPLE, FAMILIAR, SENCILLA_ALT]
